import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import { push } from 'react-router-redux';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG, DEFAULT_PUT_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { CLEAR_BOARDING_GROUP, CLEAR_BOARDING_GROUPS, FLAG_BOARDING_GROUP_ACTIVITY, FLAG_BOARDING_GROUPS, GET_BOARDING_GROUP, GET_BOARDING_GROUPS } from "../types";
import { BOARDING_GROUP_ENDPOINT } from '../../config/endpoints';
import { BOARDING_GROUP_PATH } from '../../config/paths';


const flagBoardingGroups = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BOARDING_GROUPS,
    payload: flag,
  });

const getBoardingGroups = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagBoardingGroups(true));
    const query = tableFilters;
    const url = `${BOARDING_GROUP_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_BOARDING_GROUPS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagBoardingGroups(false));
  }
}

const clearBoardingGroups = () => (dispatch) =>
  dispatch({
    type: CLEAR_BOARDING_GROUPS,
  });

const flagBoardingGroupActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BOARDING_GROUP_ACTIVITY,
    payload: flag,
  });

const getBoardingGroup =
  async ({ boardingGroupId }) =>
    async (dispatch) => {
      try {
        dispatch(flagBoardingGroupActivity(true));
        const url = `${BOARDING_GROUP_ENDPOINT}/${boardingGroupId}`;
        const promise = await fetch(url, DEFAULT_GET_CONFIG);
        await isErrorResponse(promise, null, dispatch);
        const response = await promise.json();
        dispatch({
          type: GET_BOARDING_GROUP,
          payload: response,
        });
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagBoardingGroupActivity(false));
      }
    }

const clearBoardingGroup = () => (dispatch) =>
  dispatch({
    type: CLEAR_BOARDING_GROUP,
  });

const deleteBoardingGroup = async ({ boardingGroupId }) => async (dispatch) => {
  try {
    dispatch(flagBoardingGroupActivity(true));
    const url = `${BOARDING_GROUP_ENDPOINT}/${boardingGroupId}`;
    const response = await fetch(url, DEFAULT_DELETE_CONFIG);
    await isErrorResponse(response, null, dispatch);
    dispatch(push(BOARDING_GROUP_PATH));
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagBoardingGroupActivity(false));
  }
}

const postBoardingGroup = async (formValues) => async (dispatch) => {
  try {
    dispatch(flagBoardingGroupActivity(true));
    const url = BOARDING_GROUP_ENDPOINT;
    const response = await fetch(url, {
      ...DEFAULT_POST_CONFIG,
      body: JSON.stringify(formValues),
    });
    await isErrorResponse(response, null, dispatch);
    await response.json();
    toastr.success('Exito', 'Grupo de embarque creado exitosamente');
    dispatch(push(BOARDING_GROUP_PATH));
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagBoardingGroupActivity(false));
  }
}

const putBoardingGroup = async ({ boardingGroupId, ...formValues }) => async (dispatch) => {
  try {
    dispatch(flagBoardingGroupActivity(true));
    const url = `${BOARDING_GROUP_ENDPOINT}/${boardingGroupId}`;
    const response = await fetch(url, {
      ...DEFAULT_PUT_CONFIG,
      body: JSON.stringify(formValues),
    });
    await isErrorResponse(response, null, dispatch);
    await response.json();
    toastr.success('Exito', 'Grupo de embarque actualizado exitosamente');
    dispatch(push(BOARDING_GROUP_PATH));
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagBoardingGroupActivity(false));
  }
}


export {
  getBoardingGroups,
  clearBoardingGroups,
  getBoardingGroup,
  clearBoardingGroup,
  deleteBoardingGroup,
  postBoardingGroup,
  putBoardingGroup,
}